import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { ArtistSwitcherSheetList } from '../../../accountSelector/ArtistSwitcherSheetList';
import type { ArtistSwitcherState } from '../../../accountSelector/useArtistSwitcher';
import { artistSwitcherMessages } from '../../../accountSelector/artistSwitcherMessages';
import styles from './MobileAccountArtists.module.scss';

interface MobileAccountArtistsProps {
  switcher: ArtistSwitcherState;
  onClose: () => void;
  /** design: workspaces a3 / b1. True while a workspace opens. */
  isDisabled: boolean;
}

/**
 * design: workspaces b1 (README decision 8). The artists of the active workspace in the account
 * sheet, under the workspace part: the "Artists" header with the count, the rows and "Add artist".
 */
const MobileAccountArtistsComponent: React.FC<MobileAccountArtistsProps> = ({ switcher, onClose, isDisabled }) => {
  const intl = useIntl();
  const { accounts, ownAccountCount, artistsLimit } = switcher;
  if (accounts === undefined) {
    return null;
  }
  const header = intl.formatMessage(artistSwitcherMessages.header);
  return (
    <div role="group" aria-label={header}>
      <div className={styles.sectionHeader}>
        <span>{header}</span>
        {artistsLimit !== null && (
          <span>
            {intl.formatMessage(artistSwitcherMessages.count, { count: ownAccountCount ?? 0, limit: artistsLimit })}
          </span>
        )}
      </div>
      <ArtistSwitcherSheetList switcher={switcher} onClose={onClose} isDisabled={isDisabled} />
    </div>
  );
};

export const MobileAccountArtists = TypedMemo(MobileAccountArtistsComponent);
